import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/terminos")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "es",
    title: "Términos de servicio: Shugert",
    description: "Los términos que rigen el uso de shugert.com.mx y los servicios de desarrollo Shopify, SEO y CRO de Shugert Agency: honorarios, PI y responsabilidad.",
    path: "/es/terminos",
    altPath: alternatePath("/es/terminos", "en"),
  }),
});
